import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import MaterialTable from "../../components/Table/MaterialTable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
const BookingActivityList = () => {
  const [activities, setActivities] = useState([]);
  const [hotelMap, setHotelMap] = useState({});

  const columns = [
    { field: "booking_id", title: "Booking ID" },
    { field: "hotel_name", title: "Hotel" },
    { field: "channel_id", title: "Channel" },
    { field: "activity_id", title: "Activity ID" },
    { field: "start_time", title: "Start Time" },
    { field: "end_time", title: "End Time" },
    { field: "rateperunit", title: "Rate Per Unit" },
    { field: "total_rate", title: "Total Rate" },
  ];

  useEffect(() => {
    const fetchActivitiesAndHotels = async () => {
      try {
        // Fetch hotel data
        const hotelResponse = await fetch("https://api.esthell.com/Hotel");
        const hotelData = await hotelResponse.json();

        // Create hotel_id to hotel name map
        const hotelMapData = {};
        if (hotelData.success && Array.isArray(hotelData.data)) {
          hotelData.data.forEach((hotel) => {
            hotelMapData[hotel.hotel_id] = hotel.name;
          });
        }

        setHotelMap(hotelMapData);

        // Fetch booking activity data
        const activityResponse = await fetch(
          "https://api.esthell.com/BookingActivityList",
        );
        const activityData = await activityResponse.json();

        if (activityData.success && Array.isArray(activityData.data)) {
          // Map hotel_id to hotel_name
          const transformedData = activityData.data.map((item) => ({
            ...item,
            hotel_name: hotelMapData[item.hotel_id] || item.hotel_id,
          }));
          setActivities(transformedData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchActivitiesAndHotels();
  }, []);
  const exportToExcel = () => {
    const exportData = activities.map((item) => ({
      BookingID: item.booking_id,
      Hotel: item.hotel_name,
      Channel: item.channel_id,
      ActivityID: item.activity_id,
      StartTime: item.start_time,
      EndTime: item.end_time,
      RatePerUnit: item.rateperunit,
      TotalRate: item.total_rate,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Booking Activities");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const fileData = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(fileData, "BookingActivityList.xlsx");
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography
        variant="h4"
        sx={{ mb: 3, color: "#1a237e", fontWeight: "bold" }}
      >
        Booking Activity List
      </Typography>
      <Button variant="contained" color="primary" onClick={exportToExcel}>
        Export to Excel
      </Button>
      <MaterialTable
        columns={columns}
        data={activities}
        printTitle="Booking Activity List"
        enableRowActions={false}
        options={{
          search: false,
          filtering: false,
          editing: false,
          actionsColumnIndex: -1,
          paging: true,
          pageSize: 10,
          pageSizeOptions: [10, 20, 30],
        }}
      />
    </Box>
  );
};

export default BookingActivityList;
